/* data-slides-visible="four" oppure data-slides-visible="one" 

document.addEventListener("DOMContentLoaded", function() {
    initializeSlider("slides-container-kom-header-desktop", "slide-kom-header-desktop");
    initializeSlider("slides-container-kom-header-mobile", "slide-kom-header-mobile");
});

function initializeSlider(containerId, slideClass) {
    const slides = document.getElementById(containerId);

    if (!slides) {
        // Se l'elemento non esiste, interrompi l'esecuzione della funzione
        return;
    }
  
    let index = 0;
    const totalSlides = document.querySelectorAll(`.${slideClass}`).length;
    let startX, currentX, movedBy;
    let isDragging = false;

    function getPosX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function startDrag(event) {
        isDragging = true;
        startX = getPosX(event) - slides.offsetLeft;
        movedBy = 0;
        slides.style.transition = 'none';
    }

    function moveSlide(event) {
        if (!isDragging) return;
        currentX = getPosX(event) - slides.offsetLeft;
        movedBy = currentX - startX;
        const moveSlideBy = -index * 100 + movedBy / slides.offsetWidth * 100;
        slides.style.transform = `translateX(${moveSlideBy}%)`;
    }

    function endDrag() {
        isDragging = false;
        const slidesVisible = slides.getAttribute('data-slides-visible');
        let slidesMove;
        
        switch (slidesVisible) {
            case 'four':
                slidesMove = 25;
                break;
            case 'three':
                slidesMove = 33.3333;
                break;
            default:
                slidesMove = 100;
                break;
        }
    
        if (Math.abs(movedBy) > slides.offsetWidth / 4) {
            if (movedBy > 0 && index > 0) index--;
            else if (movedBy < 0 && index < totalSlides - (slidesVisible === 'four' ? 4 : slidesVisible === 'three' ? 3 : 1)) index++;
        }
        slides.style.transition = 'transform 0.3s ease-out';
        slides.style.transform = `translateX(-${index * slidesMove}%)`;
    }



    // Eventi per il mouse
    slides.addEventListener('mousedown', startDrag);
    slides.addEventListener('mousemove', moveSlide);
    slides.addEventListener('mouseup', endDrag);
    slides.addEventListener('mouseleave', () => { if (isDragging) endDrag(); });

    // Eventi per il touch
    slides.addEventListener('touchstart', startDrag);
    slides.addEventListener('touchmove', moveSlide);
    slides.addEventListener('touchend', endDrag);
}*/

// rimozione countdown se vuoto
document.addEventListener("DOMContentLoaded", function() {
  var countdownBlocks = document.querySelectorAll('.countdown-timer-block');

  countdownBlocks.forEach(function(block) {
    if (block.innerHTML.trim() === '') {
      var parentSlide = block.closest('.splide__slide');
      if (parentSlide) {
        parentSlide.remove();
      }
    }
  });
});


// script menu secondo livello
document.addEventListener('click', function(event) {
    if (event.target.matches('.kom-apertura-menu')) {
        event.preventDefault();
        
        // Trova il menu più vicino all'elemento cliccato
        var closestMenu = event.target.closest('.kom-menu-lv2');
        if (closestMenu) {
            closestMenu.classList.add('kom-is-open');
        }
    }

    if (event.target.matches('.kom-apertura-menu svg')) {
        event.preventDefault();
        
        // Trova il menu più vicino all'elemento cliccato
        var closestMenu = event.target.closest('.kom-menu-lv2');
        if (closestMenu) {
            closestMenu.classList.add('kom-is-open');
        }
    }

    // Gestisci anche la chiusura del menu
    if (event.target.matches('.kom-chiusura-menu span')) {
        var closestMenu = event.target.closest('.kom-menu-lv2');
        if (closestMenu) {
            closestMenu.classList.remove('kom-is-open');
        }
    }

    if (event.target.matches('.kom-chiusura-menu svg')) {
        var closestMenu = event.target.closest('.kom-menu-lv2');
        if (closestMenu) {
            closestMenu.classList.remove('kom-is-open');
        }
    }
}, { capture: true });